import React, { useEffect, useState } from 'react';
import { Container, Card, Table, Button, ButtonGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateSearch, postsearchTextAll, resetList, getStaffUnderSU, updateTransfer, transferSupervisor, updateSelectedSU, addtransferSupervisor, getLeftSupervisorWithActiveEmployee } from "../../3.Store/EmployeeSlice";
import { ThreeDots } from 'react-loader-spinner';
import Swal from "sweetalert2";
import Pagination from '../../2.Commons/Pagination';
import Select from "react-select";
import moment from "moment/moment";

const SupervisorStaffManagement = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [table, setTable] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [inputValue2, setInputValue2] = useState("");
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const employees = useSelector(state => state.EmployeeSlice.employees);
    const transfer = useSelector(state => state.EmployeeSlice.transfer);
    const employeeLists = useSelector(state => state.EmployeeSlice.supervisorStaff);
    const selectedSupervisor = useSelector(state => state.EmployeeSlice.selectedSupervisor);
    const leftsupervisor = useSelector(state => state.EmployeeSlice.leftsupervisor);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [selectedOption, setSelectedOption] = useState(null);
    const [showTransfer, setShowTransfer] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [newSupervisorOption, setNewSupervisorOption] = useState(null);
    const [pendingSelection, setPendingSelection] = useState(null);
    const [employeeid, setemployeeid] = useState(null);
    const pageSize = 20; // Number of items per page
    const totalPages = Math.ceil(employeeLists.length / pageSize);
    const totalPages1 = Math.ceil(leftsupervisor.length / pageSize);
    // const [searchText, setSearchText] = useState('');
    const role = JSON.parse(localStorage.getItem("roles"));

    console.log(selectedSupervisor);
    console.log(selectedOption);
    console.log(employees);
    console.log(leftsupervisor);
    
    useEffect(() => {
      if (!role || !role.includes("HR-SU-TRANS")) {  // Check required role 
        localStorage.clear(); 
        window.location.href = "/Login";
      }
      else {
        dispatch(getLeftSupervisorWithActiveEmployee());
        setShowTable(true);
        setShowTransfer(false);
      }
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
      if (Array.isArray(employeeLists)) {
        const entity = {
          ...transfer,
          staffList: employeeLists.map(emp => emp.id),
        };
        console.log(entity);
        dispatch(updateTransfer(entity));
      }
    }, [employeeLists]);

    useEffect(() => {
      if(selectedSupervisor.id !== "") {
        setTable(true);
        setSelectedOption(selectedSupervisor.name);
        setemployeeid(selectedSupervisor);
        dispatch(getStaffUnderSU({ id: selectedSupervisor.id }))
      }
      else{
        setTable(false);
      }
    }, [selectedSupervisor.id]);

    useEffect(() => {
      if (inputValue && inputValue.length > 2) {
        const entity = { searchText: inputValue, active: 1}
        dispatch(postsearchTextAll(entity));
      }
    }, [inputValue]);

    useEffect(() => {
      if (inputValue2 && inputValue2.length > 2) {
        const entity = { searchText: inputValue2, active: 1}
        dispatch(postsearchTextAll(entity));
      }
    }, [inputValue2]);

    // Map employee names to options
    const options = employees.map(employee => ({
      label: employee.fullname,
      value: employee.fullname,
      id: employee.id
    }));

    useEffect(() => {
      if (pendingSelection && options.length > 0) {
        // Check if the option is now available
        const matched = options.find(opt => opt.id === pendingSelection.id);
        if (matched) {
          handleDropdownEmployee(pendingSelection.name);
          setPendingSelection(null); // Reset
        }
      }
    }, [options, pendingSelection]);

    const handleDropdownEmployee = (selectedOption) => {
      console.log(selectedOption);
      console.log(options);
      // Find the selected option based on ID
      const selectedEmployee = options.find(option => option.id === selectedOption.id);
      
      setSelectedOption(selectedEmployee);
      console.log("Selected Employee ID:", selectedEmployee?.id);
      
      setemployeeid(selectedEmployee?.id); // This update is asynchronous

      if (selectedEmployee?.id) {
        setTable(true);
        setLoading(true);
        setCurrentPage(1);
        setShowTable(false);
        setShowTransfer(false);
        dispatch(resetList());

        const entity = {...transfer, oldSupervisorId: selectedEmployee.id};
        console.log(entity);
        dispatch(updateTransfer(entity));

        const entity2 = {...selectedSupervisor, id: selectedEmployee.id, name: selectedEmployee}
        dispatch(updateSelectedSU(entity2));
    
        dispatch(getStaffUnderSU({ id: selectedEmployee.id }))
          .then(() => setLoading(false))
          .catch(() => setLoading(false));
      }
    };

    const handleTransferStaff = async () => {
      if (!newSupervisorOption || !employeeid || employeeLists.length === 0) {
        Swal.fire("Error", "Please select a new supervisor and ensure there are staff availble for transfer.", "error");
        return;
      }
    
      const confirm = await Swal.fire({
        // title: "Confirm Transfer",
        text: `Confirm to transfer all staff to ${newSupervisorOption.label}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
      });
    
      if (confirm.isConfirmed) {
        try {
          setLoading(true);
    
          // Replace this with your actual API call or dispatch
          await dispatch(transferSupervisor({ ...transfer }));
          await dispatch(addtransferSupervisor({ ...transfer}));
    
          Swal.fire("Success", "Staff transferred successfully!", "success");

          console.log(newSupervisorOption)

          const entity2 = {...selectedSupervisor, id: newSupervisorOption.id, name: newSupervisorOption}
          await dispatch(updateSelectedSU(entity2));
    
          // Refresh list
          dispatch(getStaffUnderSU({ id: newSupervisorOption.id }));

          // Reset state
          setShowTransfer(false);
          setSelectedOption(newSupervisorOption);
          setNewSupervisorOption(null);
          setInputValue2("");
    
        } catch (error) {
          console.error(error);
          Swal.fire("Error", "An error occurred while transferring staff.", "error");
        } finally {
          setLoading(false);
        }
      }
    };    

    const handlePreviousPage = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePreviousPage1 = () => {
        setCurrentPage1(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextPage1 = () => {
        setCurrentPage1(prevPage => Math.min(prevPage + 1, totalPages1));
    };

    const handlePageChange1 = (page) => {
        setCurrentPage1(page);
    };
    
    const handleClickView = (id) => {
      navigate(`/EmployeeForm/${id}`);
    };

    const handleClickTransfer = (id, name) => {
      const selected = { id, name: {label: name, value: name, id} };

      setInputValue(name);              // Trigger options update (if filtered)
      // setSelectedOption(selected.name);     // Show in Select
      setPendingSelection(selected);    // Wait until options update to process
      setShowTable(false);
      setTable(true);     
    };

    const renderStaffList = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, employeeLists.length);
    
        return employeeLists
          .slice(startIndex, endIndex)
          .map(employee => (
            <tr key={employee.id} style={{ cursor: "pointer" }}>
                {isMobile ? (
                    <>
                      <td onClick={() => handleClickView(employee.id)}>
                        {employee.fullname
                          .toLowerCase()
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                      </td>
                    </>
                ) : (
                    <>
                      <td onClick={() => handleClickView(employee.id)}>
                        {employee.fullname
                          .toLowerCase()
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                      </td>
                      <td onClick={() => handleClickView(employee.id)}>{employee.company.description}</td>
                    </>
                )}
            </tr>
          ));
    };

    const renderStaffList2 = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = Math.min(startIndex + pageSize, leftsupervisor.length);
    
        return leftsupervisor
          .slice(startIndex, endIndex)
          .map(employee => (
            <tr key={employee.supervisor_id} style={{ cursor: "pointer" }}>
                {isMobile ? (
                    <>
                      <td onClick={() => handleClickTransfer(employee.supervisor_id, employee.supervisor_name)}>
                        <div>
                          {employee.supervisor_name
                            .toLowerCase()
                            .split(' ')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ')}
                        </div>
                        <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                          Date Left: {moment(employee.dateLeft).format("YYYY-MM-DD")}
                        </div>
                      </td>
                    </>
                ) : (
                    <>
                      <td onClick={() => handleClickTransfer(employee.supervisor_id, employee.supervisor_name)}>
                        {employee.supervisor_name
                          .toLowerCase()
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                      </td>
                      <td onClick={() => handleClickTransfer(employee.supervisor_id, employee.supervisor_name)}>{moment(employee.dateLeft).format("YYYY-MM-DD")}</td>
                    </>
                )}
            </tr>
          ));
    };

    const staffIds = Array.isArray(employeeLists)
      ? employeeLists.map(emp => emp.id)
      : [];

    return (
        <div className="ContainerContent2">
        {loading && (
            <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#4fa94d"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperStyle={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '9999',
            }}
            />
        )}
        <Card className="CardContent">
            <div className="d-flex justify-content-between">
                {/* <ButtonGroup className="my-2">
                    <Button className="Button" onClick={() => navigate("/")}>
                      Back
                    </Button>
                </ButtonGroup> */}
                <ButtonGroup className="my-2">
                  <Button
                    className="Button"
                    onClick={() => {
                      if (selectedOption) {
                        setSelectedOption(null);
                        setInputValue("");       // Optional: clear the input field
                        setShowTable(true);      // Show the supervisor list
                        setTable(false);
                        dispatch(getLeftSupervisorWithActiveEmployee());
                      } else {
                        // Go back to home page
                        navigate("/");
                      }
                    }}
                  >
                    Back
                  </Button>
                </ButtonGroup>
            </div>

            <h1 className="TitleHeader">Supervisor Staff Management</h1>

            <Select
              inputValue={inputValue}
              onInputChange={(value) => setInputValue(value)}
              name="name"
              onChange={handleDropdownEmployee}
              options={options}
              value={selectedOption}
              placeholder="Search Supervisor"
              className='my-3'
            />

            {!loading &&  !selectedOption && showTable && (
              <>
              <br></br>
              <h5 className="SecondMiniTitleHeader">Resigned Supervisors with Active Staff</h5>
              <Pagination
                  currentPage={currentPage1}
                  totalPages={totalPages1}
                  handlePreviousPage={handlePreviousPage1}
                  handleNextPage={handleNextPage1}
                  handlePageChange={handlePageChange1}
              />
              <Table className="my-fixed-table" style={{ fontSize: "14px" }} >
                <thead>
                    <tr>
                        {isMobile ? (
                            <>
                              <th>Supervisor Name</th>
                            </>
                        ) : (
                            <>
                              <th style={{ width: "50px" }}>Supervisor Name</th>
                              <th style={{ width: "35px" }}>Date Left</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {leftsupervisor.length > 0 ? (
                        renderStaffList2()
                    ) : (
                        <tr>
                            {/* <td colSpan="5">No results found</td> */}
                            <td colSpan={isMobile ? "1" : "2"}>No resigned supervisor with active staff.</td>
                        </tr>
                    )}
                </tbody>
              </Table>
              <Pagination
                  currentPage={currentPage1}
                  totalPages={totalPages1}
                  handlePreviousPage={handlePreviousPage1}
                  handleNextPage={handleNextPage1}
                  handlePageChange={handlePageChange1}
              />
              </>
            )}

            {!loading && selectedOption && table && (
              <>
              <div className="d-flex align-items-center mb-3 my-4" style={{ gap: '12px' }}>
                <h6 className="SecondMiniTitleHeader mb-0" style={{ height: '38px', display: 'flex', alignItems: 'center' }}>
                  Current Supervisor: {selectedOption?.label || "-"}
                </h6>
                
                {!showTransfer && (
                  <Button
                    className="Button"
                    variant="primary"
                    style={{ height: 38, display: 'flex', alignItems: 'center' }}
                    onClick={() => setShowTransfer(true)}
                  >
                    Update
                  </Button>
                )}
              </div>

              {showTransfer && (
                <>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <h6 className="SecondMiniTitleHeader">Transfer all staff to:</h6>
                    <div style={{ flex: 1 }}>
                      <Select
                        inputValue={inputValue2}
                        onInputChange={(value) => setInputValue2(value)}
                        options={options.filter(option => option.id !== employeeid && !staffIds.includes(option.id))} // exclude current
                        value={newSupervisorOption}
                        // onChange={setNewSupervisorOption}
                        onChange={(selected) => {
                          setNewSupervisorOption(selected);
                      
                          const entity = {
                            ...transfer,
                            newSupervisorId: selected?.id || null,
                          };
                          console.log(entity);
                      
                          dispatch(updateTransfer(entity));
                        }}
                        placeholder="Select New Supervisor"
                        styles={{
                          control: (base) => ({
                            ...base,
                            height: 38,
                            minHeight: 38,
                            display: 'flex',
                            alignItems: 'center',
                          }),
                        }}
                      />
                    </div>

                    <Button
                      className="Button"
                      variant="warning"
                      style={{ height: 38, display: 'flex', alignItems: 'center' }}
                      onClick={handleTransferStaff}
                      // disabled={!newSupervisorOption || employeeLists.length === 0}
                    >
                      Update
                    </Button>

                    <Button
                      className="Button"
                      variant="secondary"
                      style={{ height: 38, display: 'flex', alignItems: 'center' }}
                      onClick={() => {
                        setShowTransfer(false);
                        setNewSupervisorOption(null);
                        setInputValue2("");
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                  <br></br>
                </>
              )}

              <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handlePreviousPage={handlePreviousPage}
                  handleNextPage={handleNextPage}
                  handlePageChange={handlePageChange}
              />

              <Table className="my-fixed-table" style={{ fontSize: "14px" }} >
                  <thead>
                      <tr>
                          {isMobile ? (
                              <>
                                  <th>Staff</th>
                              </>
                          ) : (
                              <>
                                <th style={{ width: "50px" }}>Staff</th>
                                <th style={{ width: "35px" }}>Company</th>
                              </>
                          )}
                      </tr>
                  </thead>
                  <tbody>
                      {employeeLists.length > 0 ? (
                          renderStaffList()
                      ) : (
                          <tr>
                              {/* <td colSpan="5">No results found</td> */}
                              <td colSpan={isMobile ? "1" : "2"}>No staffs found under this name.</td>
                          </tr>
                      )}
                  </tbody>
              </Table>

              <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handlePreviousPage={handlePreviousPage}
                  handleNextPage={handleNextPage}
                  handlePageChange={handlePageChange}
              />
            </>
            )}
            
            <div className="d-flex justify-content-between">
                <ButtonGroup>
                    {/* <Button className="Button" onClick={() => navigate("/")}>
                    Back
                    </Button> */}
                    <Button
                      className="Button"
                      onClick={() => {
                        if (selectedOption) {
                          // Clear selected supervisor and show the resigned supervisor list again
                          setSelectedOption(null);
                          setInputValue("");       // Optional: clear the input field
                          setShowTable(true);      // Show the supervisor list
                          setTable(false);
                          dispatch(getLeftSupervisorWithActiveEmployee());  
                        } else {
                          // Go back to home page
                          navigate("/");
                        }
                      }}
                    >
                      Back
                    </Button>
                </ButtonGroup >
                &nbsp; &nbsp;
                <ButtonGroup>
                </ButtonGroup>
            </div>
        </Card>
        </div>
    );
};

export default SupervisorStaffManagement;